import { DIFFICULTY_OPTIONS, sanitizeDifficultyId, type DifficultyId } from "../gameplay/Difficulty";

export function difficultyOptionsMarkup(selected: DifficultyId, compact = false): string {
  const current = sanitizeDifficultyId(selected);
  return `<div class="difficulty-options${compact ? " compact" : ""}" role="radiogroup" aria-label="Tahap kesukaran">${DIFFICULTY_OPTIONS.map((preset, index) => `
    <button type="button" class="difficulty-option danger-${index + 1}${preset.id === current ? " selected" : ""}" data-difficulty="${preset.id}" role="radio" aria-checked="${preset.id === current}">
      <span class="difficulty-name">${preset.label.toUpperCase()}</span>
      <span class="difficulty-description">${preset.description.replace("\n", "<br>")}</span>
    </button>`).join("")}</div>`;
}

export function bindDifficultyOptions(root: ParentNode, initial: DifficultyId, onSelect: (id: DifficultyId, button: HTMLButtonElement) => void): () => DifficultyId {
  let selected = sanitizeDifficultyId(initial);
  const buttons = [...root.querySelectorAll<HTMLButtonElement>("[data-difficulty]")];
  const update = (): void => buttons.forEach((button) => {
    const isSelected = button.dataset.difficulty === selected;
    button.classList.toggle("selected", isSelected);
    button.setAttribute("aria-checked", String(isSelected));
  });
  buttons.forEach((button) => {
    button.addEventListener("pointerdown", (event) => event.stopPropagation());
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      selected = sanitizeDifficultyId(button.dataset.difficulty);
      update();
      onSelect(selected, button);
    });
  });
  update();
  return () => selected;
}
